var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.92 9.98c.02.26.02.52.02.79C27.94 20.29 20.22 28 10.7 28h-.25c-3.34.01-6.62-.93-9.44-2.72.49.05.99.08 1.49.08 2.76 0 5.45-.9 7.63-2.59a6.162 6.162 0 0 1-5.75-4.2c.38.06.77.09 1.16.09.55 0 1.09-.07 1.62-.21a6.08 6.08 0 0 1-4.93-5.94v-.07c.85.47 1.81.73 2.78.77a6.013 6.013 0 0 1-2.74-5.04c0-1.08.29-2.13.84-3.06 3.15 3.8 7.75 6.1 12.68 6.34A6.099 6.099 0 0 1 21.78 4c1.7 0 3.32.68 4.49 1.91 1.37-.26 2.69-.76 3.9-1.46a6.072 6.072 0 0 1-2.7 3.34c1.22-.14 2.41-.45 3.54-.94a13.08 13.08 0 0 1-3.08 3.13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.d72a743b4ec04eb646cb16052b3d81d9.svg";
export { ForwardRef as ReactComponent };